
export const updateFiltersBasedOnSelection = (selectedFieldName, selectedFieldValue, metaDataQu, filters, topFilters) => {
    const selectedNames = selectedFieldName;
    const selectedValues = selectedFieldValue;

// if (topFilters){
//     return [...topFilters]
// }
    const updatedFilters = selectedNames?.reduce((acc, name) => {
        const metaData = metaDataQu?.metaData.find((md) => md.name === name);

        if (metaData) {
            if (metaData.type === "number") {
                const values = selectedValues.filter((value) =>
                    metaData.values.map((v) => v.value).includes(value),
                );
                const numArray = values.map(Number);
                const minimum = Math.min(...numArray);
                const maximum = Math.max(...numArray);
                if (values.length > 0) {
                    acc.push({ name, minimum, maximum });
                }
            } else if (metaData.type === "date") {
                const filter =
                    topFilters.find((el) => el.name === name) ||
                    filters.find((el) => el.name === name);

                if (filter) {
                    acc.push({
                        name,
                        minimum: filter.minimum,
                        maximum: filter.maximum,
                    });
                }
            } else {
                const values = selectedValues.filter((value) =>
                    metaData.values.map((v) => v.value).includes(value),
                );

                if (values.length > 0) {
                    acc.push({ name, values });
                }
            }
        }
        return acc;
    }, []);

    return updatedFilters;
};
